(function () {
  'use strict';

  /* @ngdoc object
   * @name electronicLogBook
   * @description
   *
   */
  angular
    .module('electronicLogBook', [
      'ui.router'
    ]);
}());
